<template>
    <kiosk-layout formContainer>
        <page-loading v-if="loading"></page-loading>
        <div v-else>
            <page-header class="vx-mb-6 lg:vx-mb-12">
                <template v-slot:subtitle>
                    <a href="/kiosk/teams" class="!vx-no-underline !vx-text-sky-600 vx-text-base vx-font-normal">
                        <font-awesome-icon class="vx-mr-1" :icon="faArrowLeft"></font-awesome-icon>
                        Search
                    </a>
                </template>

                {{ team.name }}

                <template v-slot:actions>
                    <vx-button
                        v-if="team.status === 'active'"
                        @click="suspendModal = true"
                        data-test="suspend"
                        color="muted-dark"
                    >
                        Suspend
                        <font-awesome-icon :icon="faPause"></font-awesome-icon>
                    </vx-button>
                    <vx-button v-else @click="activateModal = true" data-test="activate" color="muted-dark">
                        {{ team.status === 'suspended' ? 'Re-Activate' : 'Activate' }}
                        <font-awesome-icon :icon="faPlay"></font-awesome-icon>
                    </vx-button>

                    <vx-button
                        color="primary"
                        :href="`/spark/kiosk/users/impersonate/${team.owner_id}?team_id=${team.id}`"
                        :disabled="team.owner_id === currentUserId"
                    >
                        Impersonate Owner <font-awesome-icon :icon="faMasksTheater"></font-awesome-icon>
                    </vx-button>
                </template>
            </page-header>

            <div class="vx-grid vx-grid-cols-12">
                <page-sidebar
                    :links="
                        [
                            { href: `/kiosk/teams/${props.teamId}`, label: 'Details' },
                            { href: `/kiosk/teams/${props.teamId}/plan-information`, label: 'Plan Information' },
                            { href: `/kiosk/teams/${props.teamId}/features`, label: 'Features' },
                            team.organization_type === 'brand'
                                ? { href: `/kiosk/teams/${props.teamId}/sub-teams`, label: 'Sub Teams' }
                                : null,
                            team.organization_type === 'brand'
                                ? {
                                      href: `/kiosk/teams/${props.teamId}/sub-teams/features`,
                                      label: 'Sub Teams Features',
                                  }
                                : null,
                            { href: `/kiosk/teams/${props.teamId}/emergency-tools`, label: 'Emergency' },
                        ].filter((link) => !!link)
                    "
                ></page-sidebar>

                <slot></slot>
            </div>
        </div>

        <kiosk-team-suspend-modal
            v-if="team"
            v-model:visible="suspendModal"
            v-model:team="team"
        ></kiosk-team-suspend-modal>
        <kiosk-team-activate-modal
            v-if="team"
            v-model:visible="activateModal"
            v-model:team="team"
        ></kiosk-team-activate-modal>
    </kiosk-layout>
</template>

<script setup>
import { faArrowLeft, faMasksTheater, faPause, faPlay } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { onMounted } from 'vue';
import PageLoading from '~/components/general/PageLoading.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { VxButton } from '@voxie/frontend-components';
import { useTeamDetails } from '~/components/kiosk/kiosk-teams/useTeamDetails';
import KioskLayout from '~/components/kiosk/KioskLayout.vue';
import KioskTeamSuspendModal from '~/components/kiosk/kiosk-teams/KioskTeamSuspendModal.vue';
import KioskTeamActivateModal from '~/components/kiosk/kiosk-teams/KioskTeamActivateModal.vue';
import { ref } from 'vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const { mount, team, loading } = useTeamDetails();

const suspendModal = ref(false);
const activateModal = ref(false);

const currentUserId = Spark.state.user.id;

onMounted(() => {
    mount(props.teamId);
});
</script>
